import type {
  QuestProgress,
  QuestRoute,
  RouteLandmark,
  ShareSummary,
} from "./types";

export function createShareSummary(params: {
  kind: ShareSummary["kind"];
  route: QuestRoute;
  progress?: QuestProgress;
  landmark?: RouteLandmark | null;
  badgeTitle?: string;
  itemTitle?: string;
}): ShareSummary {
  const routeTitle = params.route.title;
  switch (params.kind) {
    case "quest_started":
      return {
        kind: params.kind,
        title: `Started ${routeTitle}`,
        subtitle: "A new Fitness RPG journey is underway.",
        routeTitle,
        artAssetId: params.route.shareMeta.ogImageAssetId,
      };
    case "landmark_reached":
      return {
        kind: params.kind,
        title: params.landmark
          ? `Reached ${params.landmark.title}`
          : "Reached a new landmark",
        subtitle: "Another bright stop on the journey.",
        routeTitle,
        artAssetId: params.landmark?.assetId ?? params.route.shareMeta.ogImageAssetId,
      };
    case "chest_opened":
      return {
        kind: params.kind,
        title: params.itemTitle
          ? `Opened ${params.itemTitle}`
          : "Opened a quest chest",
        subtitle: "A new collectible joined the pack.",
        routeTitle,
        artAssetId: params.route.shareMeta.ogImageAssetId,
      };
    case "badge_earned":
      return {
        kind: params.kind,
        title: params.badgeTitle ?? `${routeTitle} badge earned`,
        subtitle: "A route milestone is complete.",
        routeTitle,
        artAssetId: params.route.shareMeta.ogImageAssetId,
        statLine: params.progress
          ? `${Math.round(params.progress.percentComplete)}% complete`
          : undefined,
      };
    case "weekly_recap":
      return {
        kind: params.kind,
        title: `${routeTitle} weekly recap`,
        subtitle: "A week of steady quest progress.",
        routeTitle,
        artAssetId: params.route.shareMeta.ogImageAssetId,
      };
    case "park_chest_collected":
      return {
        kind: params.kind,
        title: params.itemTitle ?? "Park chest collected",
        subtitle: "Another national park joined the passport.",
        routeTitle,
        artAssetId: params.route.shareMeta.ogImageAssetId,
      };
  }
}
